import React, { useState, useEffect } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { ReactComponent as Remove } from '../../../assets/049-close.svg'
import { sendImg } from '../api/websocket';
import { getUploadUrl, } from '../api/index';
import { getMediaFullUrl } from '../../../helper/getMediaFullUrl';
export const ChoiceInput = ({ updateChoiceImage, choice, choiceIndex, setChoiceTitles, questionIndex, removeChoice }) => {
    const [currChoice] = useState(choice);
    const [image, setBackgroundImage] = useState('')
    const [contentRef, setContentRef] = useState(null);

    const changeChoiceTitle = (e) => {
        e.preventDefault();
        setChoiceTitles(questionIndex, choiceIndex, e?.target?.value)
    }

    function previewImage(params) {
        const preview = contentRef
        const file = params.target.files[0];
        if (!file) {
            return;
        }
        const type = file.type;
        const reader = new FileReader();

        const the = {}
        reader.onload = function (e) {
            the.type = type;
            the.blob = e.target.result;
            setBackgroundImage(the)
            preview.src = reader.result;
        }

        if (file) {
            reader.readAsDataURL(file);
        }
    }

    function removeImage(e) {
        e.preventDefault();
        contentRef.src = ''
        setBackgroundImage('')
        updateChoiceImage({ imageUrl: '', questionIndex, choiceIndex })
    }

    useEffect(() => {
        const updateImage = async () => {
            if (!image || !image.type) {
                return;
            }
            try {
                const url = await getUploadUrl({ image })
                const imageUrl = await sendImg({ url: url?.data?.url, file: image })
                if (imageUrl && imageUrl.length) {
                    contentRef.src = imageUrl
                    updateChoiceImage({ imageUrl, questionIndex, choiceIndex })
                }
            } catch (error) {
                console.error(error);
            }
        }
        updateImage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image])

    return (<div style={{
        display: 'flex',
        marginTop: '13px',
        justifyContent: 'space-between',
        position: 'relative',
    }}>
        {
            choiceIndex > 2 &&
            <Remove
                style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    backgroundColor: 'white',
                    padding: '5px',
                    width: '24px',
                    borderRadius: '50px',
                    top: '-6px',
                    left: '-8px',
                }}
                onClick={() => removeChoice(choiceIndex, questionIndex)}
            />
        }
        <input style={{
            width: '94%',
        }} defaultValue={currChoice.title} onInput={changeChoiceTitle} type="text" className="form-control form-control-solid" placeholder="Type The choice name" />
        <div className="image-input image-input-outline ml-4" style={{ borderRadius: '6px' }}>
            <img alt=""
                src={getMediaFullUrl(contentRef?.src || choice.image || '')}
                style={{ maxWidth: '70px', objectFit: 'cover', borderRadius: '6px' }}
                ref={setContentRef}
            />
            {choice.image && choice.image.length ?
                <label onClick={removeImage} className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
                    <Remove
                        style={{
                            cursor: 'pointer',
                            width: '10px'
                        }}
                    />
                </label> :
                <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
                    <img alt=""
                        src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                        style={{ width: '60%' }}
                    />
                    <input onChange={previewImage} type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" />
                    <input type="hidden" name="profile_avatar_remove" />
                </label>
            }

        </div>
    </div >
    )
}
